import * as $ from 'jquery';
import { DefaultService } from '../../common/services/DefaultService';
import { apiBaseUrlUser } from '../../../constants/url.constant';
import { PhoneModel } from '../models/PhoneModel';

export class CustomerPhoneService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/customerPhone`;

    public RouteCreate = () => `${this.baseUrl}/create`;
    public create(model: PhoneModel): JQueryPromise<any> {
        return $.ajax(this.RouteCreate(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteEdit = () => `${this.baseUrl}/edit`;
    public edit(model: PhoneModel): JQueryPromise<any> {
        return $.ajax(this.RouteEdit(), {
            type: 'put',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteDelete = (id: number) => `${this.baseUrl}/delete?id=${id}`;
    public delete(id: number): JQueryPromise<any> {
        return $.ajax(this.RouteDelete(id), {
            type: 'delete',
            data: undefined,
            contentType: 'application/json'
        });
    }

    public RouteGetList = () => `${this.baseUrl}/getList`;
    public getList(): JQueryPromise<any> {
        return $.ajax(this.RouteGetList(), {
            type: 'get',
            contentType: 'application/json'
        });
    }
}